'use client';

import { c as _c } from "react/compiler-runtime";
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';
import { flagsContext } from '@/contexts/flagsContext';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
export const LaunchDarklyProvider = props => {
  const $ = _c(30);
  const {
    isDev,
    isDemo,
    isTest,
    launchDarklyClientId
  } = useEnvironment();
  const {
    currentProjectId,
    user
  } = useUser();
  if (!currentProjectId) {
    return props.children;
  }
  if (isDemo || isDev || isTest) {
    const t0 = !isDemo;
    const t1 = isDev || isDemo;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        view: true,
        trend: true,
        export: true,
        audit: false
      };
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        mode: "agent_only"
      };
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== isDev || $[3] !== t0 || $[4] !== t1) {
      t4 = {
        NonCognitoEonAccounts: false,
        SkipOnboarding: false,
        dlsgFrontend: false,
        LlgFrontend: false,
        InventoryStatusColumns: isDev,
        GcpPermissionGroupEnforcement: true,
        AwsPermissionGroupEnforcement: true,
        enableHourlyBackup: false,
        AzureSqlVirtualMachineSupport: true,
        AzureSqlManagedInstanceSupport: true,
        MySqlFlexibleServerSupport: true,
        ownCustomerOnboardingEnabled: false,
        hourlyDlsgPolicyEnabled: false,
        SecurityFindings: true,
        AllowAccountLevelSamlWhenOrgAttached: false,
        InventoryFilterOmnibox: true,
        EnableGDSGPage: isDev,
        EnableGdsgNotifications: false,
        StorageGatewayCostExplorer: isDev,
        CostExplorerUsdToOtherCurrencies: isDev,
        EnableGdsgObjectActions: false,
        EnableGdsgInventoryReports: isDev,
        SupportColdTierVaults: true,
        AiAssistantSidebar: true,
        SapHanaPitrSupport: true,
        MongoAtlasSupport: true,
        MongoAtlasNonAwsClusters: isDev,
        MongoAtlasAdvancedRestoreEnabled: isDev,
        GcpSqlVirtualMachineSupport: true,
        ExploreFilesForDatabaseVms: true,
        RdsRestoreWithoutEncryptionEnabled: false,
        RecordRestoreResultsEnabled: true,
        GcpVmHighFrequencyBackupEnabled: true,
        RdsHighFrequencyBackupEnabled: true,
        EnableCrossCloudKvRecordRestore: true,
        EnableCrossCloudKvRecordRestoreAzure: true,
        AzureSnapshotsDiscoverySupport: true,
        AzureAdeBackupSupport: true,
        AzureVmDesRestoreSupport: true,
        AwsUntaggedRecoveryPointDiscovery: true,
        AzureMssqlTdeCmkRestore: true,
        AwsRdsNativeBackupSupport: true,
        ShadowClassificationPolicy: true,
        AwsEksClusterBackupSupport: true,
        AwsEc2InAccountBackupSupport: true,
        AzureMultipleAppRegistrations: false,
        AzureCustomPermissionsModel: false,
        GoogleWorkspaceSupport: true,
        GoogleWorkspaceEnableRansomwareDetection: true,
        GwsInPlaceRestoreOnly: false,
        GwsRestoreToTargetMailbox: true,
        GwsRestoreToTargetDrive: true,
        GwsRestoreWholeSharedDrive: true,
        Microsoft365Support: true,
        Microsoft365RestoreSupport: true,
        EnableRansomwareDetectionM365: true,
        M365TeamsSupport: true,
        M365TeamsChatsSupport: t0,
        M365RestoreToAnotherUser: true,
        EntraIdSupport: true,
        EntraIdApplicationEstate: true,
        EntraIdAdministrativeUnits: false,
        UnifiedSearch: t1,
        EnableMrapForByov: true,
        BigQueryNativeRestoreEnabled: true,
        EnableBigQueryNativePolicy: true,
        GcpProjectLabelTagFilterEnabled: true,
        CancelBackupJobEnabled: true,
        BigQueryRestoreOverwriteEnabled: true,
        SensitivityAnnotations: true,
        EnableNetworkClassification: true,
        RdsRestorePreserveOriginalMemberNames: false,
        CassandraSupport: true,
        DataPlatformConsoleEnabled: true,
        DataEngineDefaultLanding: false,
        RdsCdcUiEnabled: true,
        LakehouseMetricExportEnabled: true,
        LakehouseSqlAssistant: true,
        RolePermissionFamiliesEnabled: true,
        UnifiedIdentityRestore: true,
        AiAgents: isDev,
        AiDashboardsSupport: true,
        AiAgentCostExplorer: isDev,
        ZeroEtlEnabled: true,
        LakehouseEnabled: false,
        ZeroEtlMultiResourcePolicies: false,
        ZeroEtlBackupPolicyLink: true,
        ZeroEtlIntegrationsEnabled: true,
        DataKnowledgeGraphEnabled: false,
        AgenticDataLayerEnabled: false,
        LakehouseCustomerOwnedCatalogs: false,
        StreamlakeLakehouseScreens: true,
        StreamlakePipelineCostChartsEnabled: isDev,
        StreamlakePipelineStorageAPICostChartsEnabled: false,
        StreamlakePipelineTuning: false,
        EnableExportAccessDeniedItems: true,
        InventoryIssuesColumn: false,
        RestoreTemplates: true,
        BulkRestore: true,
        EnableYaraScan: true,
        RemediationOrchestration: true,
        EnableInventoryEntitiesFilter: true,
        DataClassificationCredentialsEnabled: false,
        SaasInventoryDefaultLanding: false,
        BackupComplianceJson: t2,
        EnableSnapshotArchitect: true,
        UseTargetVpcForRestoreServer: true,
        UseTargetVpcForFileRestoreServer: true,
        EnableGcpInstantRestore: true,
        ShovalCdcMode: t3,
        PolicyAndVaultMetadataLabels: true
      };
      $[2] = isDev;
      $[3] = t0;
      $[4] = t1;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {};
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t4) {
      t6 = {
        flags: t4,
        flagKeyMap: t5,
        ldClient: undefined
      };
      $[7] = t4;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== props.children || $[10] !== t6) {
      t7 = <flagsContext.Provider value={t6}>{props.children}</flagsContext.Provider>;
      $[9] = props.children;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    return t7;
  }
  if (!launchDarklyClientId || !user?.eonAccount) {
    return props.children;
  }
  let t0;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      reactContext: flagsContext,
      useCamelCaseFlagKeys: false
    };
    $[12] = t0;
  } else {
    t0 = $[12];
  }
  let t1;
  if ($[13] !== currentProjectId || $[14] !== user.eonAccount.domain || $[15] !== user.eonAccount.name) {
    t1 = {
      key: currentProjectId,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain
    };
    $[13] = currentProjectId;
    $[14] = user.eonAccount.domain;
    $[15] = user.eonAccount.name;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] !== currentProjectId || $[18] !== user.eonAccount.domain || $[19] !== user.eonAccount.id || $[20] !== user.eonAccount.name) {
    t2 = {
      key: user.eonAccount.id,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain,
      projectId: currentProjectId
    };
    $[17] = currentProjectId;
    $[18] = user.eonAccount.domain;
    $[19] = user.eonAccount.id;
    $[20] = user.eonAccount.name;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== t1 || $[23] !== t2) {
    t3 = {
      kind: "multi",
      user: t1,
      organization: t2
    };
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      streaming: false
    };
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== launchDarklyClientId || $[27] !== props.children || $[28] !== t3) {
    t5 = <LDProvider reactOptions={t0} clientSideID={launchDarklyClientId} timeout={2} context={t3} options={t4}>{props.children}</LDProvider>;
    $[26] = launchDarklyClientId;
    $[27] = props.children;
    $[28] = t3;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  return t5;
};